import FbbcPortalDemoPoster from "../../../../../images/posters/fbbc/walkthroughs/portal-walkthrough.webp";

const fbbcWalkthroughs = [
  { 
    "title": "Fit Body Coaching Portal Walkthrough",
    "videoUrl": "https://cdn.avatarnutrition.com/avatar-video-presentations/Fit+Body+Nutrition+Portal+Walkthrough.mp4",
    "thumbnail": FbbcPortalDemoPoster,
    "length": "26:23",
    "starred": true,
    "timestamps": [
      {
        "title": "0:00 - Intro",
        "time": 0
      },
      {
        "title": "0:19 - Coaching Overview",
        "time": 19
      },
      {
        "title": "5:01 - Inspect Account",
        "time": 301
      },
      {
        "title": "8:06 - Edit Account",
        "time": 486
      },
      {
        "title": "11:21 - Templates",
        "time": 681
      },
      {
        "title": "12:37 - Messaging",
        "time": 757
      },
      {
        "title": "13:50 - Groups",
        "time": 830
      },
      {
        "title": "18:31 - Client Registration Flow",
        "time": 1111
      },
      {
        "title": "23:09 - Billing",
        "time": 1389
      },
      {
        "title": "24:57 - Why You Should Add Yourself and Your Team as Clients",
        "time": 1497
      },
      {
        "title": "26:05 - Conclusion",
        "time": 1565
      }
    ]
  },
];

export default fbbcWalkthroughs;
